<div class="selector-container" [class.animating]="isAnimating">
  <div
    tabindex="0"
    #selectorElement
    [ngClass]="[
      'selector-tag',
      'selector-tag-' + color,
      'selector-tag-' + size,
      disabled ? 'disabled' : '',
      error ? 'error' : ''
    ]"
    (click)="togglePanel()"
    (keydown)="onKeyDown($event)"
  >
    <span class="selector-value">
      {{ getDisplayValue() }}
    </span>
    <ds-icon icon="down-arrow" class="icon"></ds-icon>
  </div>

  <ng-template #optionListContent>
    <div class="option-list" [ngClass]="['option-list-' + size]" [@fadeInOut]="animationState">
      <div class="option-list-content">
        <ng-content></ng-content>
        <ds-option *ngIf="!hasOptions" [default]="true" value="">{{ emptyOptionsText }}</ds-option>
      </div>
    </div>
  </ng-template>
</div>
